import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'formly-field-text',
  template: `
    <input
      matInput
      [id]="id"
      type="text"
      autocomplete="{{to.autoComplete || ''}}"
      [readonly]="to.readonly"
      [required]="to.required"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabindex]="to.tabindex"
      [suffix]="to.ngxMask?.suffix || ''"
      [thousandSeparator]="to.ngxMask?.thousandSeparator"
      prefix="{{ to.ngxMask?.prefix }}"
      [hiddenInput]="to.ngxMask?.hiddenInput"
      [patterns]="to.ngxMask?.patterns"
      [mask]="to.ngxMask?.mask"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTextComponent extends FieldType<FieldTypeConfig> {
  @ViewChild(MatInput) formFieldControl!: MatInput;

}
